var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selector !== null)?_c('div',{staticClass:"highlight",style:({
    left: `${_vm.position.left || '0px'}`,
    top: `${_vm.position.top || '0px'}`,
    width: `${_vm.position.width || '0px'}`,
    height: `${_vm.position.height || '0px'}`,
  })},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }